import type { ReactNode } from 'react';

export type ContentBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'list'; items: string[] };

export function renderContentBlocks(
  content: ContentBlock[],
  keyPrefix: string,
): ReactNode {
  return content.map((block, j) => {
    const key = `${keyPrefix}-${j}`;
    if (block.type === 'paragraph') {
      return <p key={key}>{block.text}</p>;
    }
    if (block.type === 'list') {
      return (
        <ul key={key} className="ml-4 list-disc space-y-0.5">
          {block.items.map((item, k) => (
            <li key={`${key}-item-${k}`}>{item}</li>
          ))}
        </ul>
      );
    }
    return null;
  });
}
